/**
 * Check if app is launched in browser or in pwa mode
 * @returns
 */
export const isPwa = (): boolean => {
  const userAgent = navigator.userAgent;
  const standalone = window && window.matchMedia('(display-mode: standalone)').matches;

  return !!(standalone || (isIosDevice() && !userAgent.match(/Safari/)));
};

/**
 * Returns if device is on ios
 * @returns
 */
export const isIosDevice = (): boolean => {
  const UA = navigator.userAgent;

  return UA.match(/iPhone|iPad|iPod/) != null;
};
